/**
 * Created by Marcus Zhao on 11/28/2020
 * Description:
 * ---------maintenance history-------------
 */

import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import * as _lodash from 'lodash';
import { UUID } from 'angular2-uuid';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { CompanyAction, ContactAction, ContactTemplateType, JobTitleAction } from '../../../contact-dialog-new/contact-dialog.model';
import { OnDestroy } from '@angular/core';

@Component({
    selector: 'tam-contact-current-employment',
    templateUrl: './contact-current-employment.component.html',
    styleUrls: ['./contact-current-employment.component.scss'],
    standalone: false
})
export class ContactCurrentEmploymentComponent implements OnInit, OnDestroy {
    @Input() childConfig;
    @ViewChild('dropDownEl', { static: false }) entityEl;
    config: any;
    inputValue = '';
    selectedItem: any;
    suggestionItems: Array<any> = [];
    private _companyId = '';
    private _destroySubscriptions: Array<Subscription> = [];
    constructor(
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
    ) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();
        } else if (this.config.action === ContactTemplateType.NewContact && this.config.defaultValue) {
            this.inputValue = this.config.defaultValue.value;
            this.selectedItem = this.config.defaultValue.startYear;
        }
        this._getEmploymentSuggestionYear();
        this._destroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(action => {
                const id = action.payload.controlID;
                if (action.type === CompanyAction.ChangeCompany && this.config.action === ContactTemplateType.NewContact) {
                    this._companyId = action.payload.targetCompany.id;
                    this._changeValueSet();
                }
            }),
        );
        this._changeValueSet();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    clickAddCtrol(item) {
        const newCtrlJson = _lodash.cloneDeep(this.childConfig);
        newCtrlJson.config.controlID = newCtrlJson.config.type + UUID.UUID();
        newCtrlJson.config.isCanDelete = true;
        newCtrlJson.config.defaultValue = item;
        this._contactTemplateService.actionSubject$.next({
            type: ContactAction.AddControl,
            payload: {
                ctrlType: this.childConfig.config.controlType,
                ctrl: newCtrlJson,
                secSName: this.childConfig.config.secSName,
                controlID: this.childConfig.config.controlID,
            }
        });
    }

    clearValue() {
        const event = new UIEvent('kendodropdown_keydown');
        event['keyCode'] = 27;
        this.entityEl.keydown(event);
        this.inputValue = '';
        this.selectedItem = null;
        this._changeValueSet();
    }

    /**
     * year changed
     * @memberof ContactCurrentEmploymentComponent
     */
    valueChange(item) {
        this.selectedItem = item;
        this._changeValueSet(true);
    }

    handleFilter(value) {
        this.suggestionItems = [];
        const startYear = new Date().getFullYear();
        for (let i = startYear; i >= 1970; i--) {
            if (i.toString().indexOf(value) !== -1) {
                this.suggestionItems.push(i);
            }
        }
    }

    private _initEditValue() {
        const dataValue = this.config.editValue;
        if (dataValue) {
            this.inputValue = dataValue.value;
            this.selectedItem = dataValue.startYear;
            this._changeValueSet(true);
        }
    }

    /**
     * init years
     *
     * @private
     * @memberof ContactCurrentEmploymentComponent
     */
    private _getEmploymentSuggestionYear() {
        this.suggestionItems = [];
        const startYear = new Date().getFullYear();
        for (let i = startYear; i >= 1970; i--) {
            this.suggestionItems.push(i);
        }
    }

    /**
     *  set value
     *
     * @param {boolean} [isFromUser=false]
     * @memberof ContactCurrentEmploymentComponent
     */
    _changeValueSet(isFromUser: boolean = false) {
        const startDate = this.selectedItem;
        const titleType = this.config.action === ContactTemplateType.NewContact ? this.config.defaultValue.id : this.config.editValue ? this.config.editValue.id : '';
        const titleValue = this.config.action === ContactTemplateType.NewContact ? this.config.defaultValue.value : this.config.editValue ? this.config.editValue.value : '';
        const combineValue = { 'companyID': this._companyId, 'titleType': titleType, 'titleValue': titleValue, 'startDate': startDate };
        const value = new ContactTemplateControlValue(combineValue, this.config.componentType,
            this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
